import { NgModule, Component, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GatewayType } from '../enums/gateway.enum';

@Pipe({
  name: "gatewayTypePipe"
})
export class GatewayTypePipe implements PipeTransform {
  translation: any;

  constructor(private translate: TranslateService) {
    this.translate.get('Gateway').subscribe(
      data => {
        this.translation = data;
      }
    )
  }

  transform(value: any): string {
    let text;
    switch (value) {
      case GatewayType.HardGateway:
        text = this.translation.HardGateway;
        break;
      case GatewayType.SoftGateway:
        text = this.translation.SoftGateway;
        break;
    }
    return text;
  }
}
